import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { VersionCheckService } from '../services/version-check/version-check.service';
import { environment } from '../../environments/environment';

@Injectable()
export class VersionInterceptor implements HttpInterceptor {

  constructor(private versionService: VersionCheckService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('version.json')) return next.handle(req);

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const serverVersion = event.headers.get('X-App-Version');
          if (serverVersion && serverVersion !== environment.version) {
            this.versionService.promptReload();
          }
        }
      })
    );
  }
}
